import { Component } from '@angular/core';

@Component({
  selector: 'app-ngb-accordion-demo',
  templateUrl: './accordion-demo.component.html',
})
export class NgbAccordionDemoComponent {}
